import gql from "graphql-tag";

export const QUERY_CITIES = gql`
  query get_cities {
    cities {
      id
      city
      country
    }
  }
`;

export const QUERY_TIPS_WITH_STATS = gql`
  query tipsWithStats($context: String!, $platform: String, $limit: Int) {
    tipsWithStats(context: $context, platform: $platform, limit: $limit) {
      id
      title
      city
      country
      authorUsername
      pinOrder
      nbImpressions
      nbClicksDetail
      nbClicksStay22
      score
      scoreCity
    }
  }
`;

export const MUTATION_SET_PIN_ORDER = gql`
  mutation setPinOrder($tipId: String!, $pinOrder: Int, $context: String) {
    setPinOrder(tipId: $tipId, pinOrder: $pinOrder, context: $context)
  }
`;
